import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
// 必须在任何播放器创建 Audio 之前加载：它负责接管 new Audio()，
// 进入作品时统一暂停平台音乐、退出时恢复。以后新增播放器自动生效。
import './utils/platformAudio';
// 登录态自动续期：接住后端发来的新 token，避免固定过期后被踢去登录
import { installAuthTokenRefresh } from './utils/authTokenRefresh';
import './index.css';
import './styles/global.css';

// ===== PWA：注册 Service Worker（系统推送依赖它），并提前捕获安装事件 =====
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  window.__iwInstallPrompt = event;
  window.dispatchEvent(new Event('iw-install-available'));
});

installAuthTokenRefresh();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
